<template>
    <b-row>
        <b-col cols="12" md="8" class="mt-3">
            <ul v-for="(parcela, index) in datosParcelas" :key="index" class="resumen d-md-flex">
                <li class="altcolor-content">
                    <div class="text-bold oswald text-uppercase m-0 w-100">
                        {{ ++index }}. {{ parcela.precioSeleccionado.descripcion }}
                    </div>
                </li>
                <li>
                    <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                        {{ zona.nombre }}
                    </div>
                </li>
                <li class="flex-grow-1">
                    <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                        {{ $t('parcelas.n_parcela') }} {{ parcela.numero }}
                    </div>
                </li>
                <li class="text-bold pr-0">
                    <label class="h5 pr-0">{{ $t('general.precio') }}</label>
                    <div class="h5 m-lg-0">
                        {{ getTotal(parcela) | formatear_precio }}
                    </div>
                </li>
            </ul>
            <div class="mb-5">
                <label>{{ $t('parcelas.total_pagar') }}</label>
                <div class="price price-large gradient-color">
                    {{ total_con_gastos | formatear_precio }}
                </div>
            </div>
        </b-col>
        <b-col cols="12">
            <FormTerminos 
                :error="error"
                :desactivar="loading"
                @continuar="aceptarCondiciones"
            />
        </b-col>
        <ResumenPrecioComponent
            :price="total_sin_gastos"
            :price_management="total_gastos"
            :price_management_interno="datosParcelas[0].precioSeleccionado.price_management_interno"
            :iva="footer.iva_partido"
        />
        <b-col cols="12" class="mt-3 d-flex justify-content-start flex-wrap">
            <button 
                id="resumen-compra-responsive" 
                :class="['button', 'effect-button', { 'large-button': !esMovil }]" 
                :disabled="(formulario && pagar) || loading"
                @click.prevent="terminar"
            >
                <span>{{ $t('partido.continuar') }}</span>
            </button>

            <button
                id="atras-resumen"
                type="button"
                :disabled="(formulario && pagar) || loading" 
                :class="['button', 'effect-button', 'ml-2', 'compra-responsive', { 'large-button': !esMovil }]"
                @click="$emit('cambiarDatos')"
            >
                <span>{{ $t('formularios.atras') }}</span>
            </button>
            <template v-if="formulario != null && pagar" >
                <div id="formulario-compra" v-html="formulario" v-show="false"></div>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent";

    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            zona: {
                type: Object,
                required: true
            },
            jet_id: String,
            formulario: String
        },
        data() {
            return {
                pagar: false,
                error: false,
                loading: false,
                terminos: false,
                dataTerminos: {}
            }
        },
        methods: {
            terminar() {
                this.loading = true;

                if (this.terminos) {
                    this.pagar = true;

                    if (this.formulario && this.pagar) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 500);
                    } else {
                        this.$emit('terminado');
                    }

                    this.loading = false;
                } else {
                    this.error = true;
                    this.loading = false;
                }
            },
            getTotal(parcela, con_gastos) {
                let precioSeleccionado = parcela.precioSeleccionado;
                let precio = precioSeleccionado.precio;

                if (con_gastos && !precioSeleccionado.price_management_online) {
                    precio += precioSeleccionado.price_management;
                }

                return precio;
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.dataTerminos.privacidad = privacidad;
                this.dataTerminos.condiciones = condiciones;
                this.dataTerminos.comunicaciones = comunicaciones;
                this.terminos = continuar == true;
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            total_con_gastos() {
                let total = 0;

                this.datosParcelas.forEach(parcela => {
                    total += this.getTotal(parcela, true);
                });

                return total;
            },
            total_sin_gastos() {
                let total = 0;

                this.datosParcelas.forEach(parcela => {
                    total += this.getTotal(parcela, false);
                });

                return total;
            },
            total_gastos() {
                let total = 0;

                this.datosParcelas.forEach(parcela => {
                    let precio = parcela.precioSeleccionado;

                    if (!precio.price_management_interno) {
                        total += precio.price_management;
                    }
                })

                return total;
            }
        },
        components: {
            FormTerminos, ResumenPrecioComponent
        }
    } 
</script>